import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';
// Navigation menu imports removed - using custom dropdown

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    {
      name: 'Home',
      href: '/',
    },
    {
      name: 'About Us',
      href: '/about',
      children: [
        { name: 'Our Story', href: '/about/story' },
        { name: 'Corporate Structure', href: '/about/structure' },
        { name: 'Certifications', href: '/about/certifications' },
      ],
    },
    {
      name: 'Our Businesses',
      href: '/businesses',
      children: [
        { name: 'First Cuisine (Halal)', href: '/businesses/first-cuisine' },
        { name: 'PS Catering (Non-Halal)', href: '/businesses/ps-catering' },
        { name: 'FC Food Industries', href: '/businesses/fc-industries' },
      ],
    },
    {
      name: 'Our Expertise',
      href: '/expertise',
      children: [
        { name: 'Therapeutic Diets', href: '/expertise/therapeutic-diets' },
        { name: 'R&D', href: '/expertise/research-development' },
        { name: 'Compliance & Safety', href: '/expertise/compliance' },
      ],
    },
    {
      name: 'OEM Services',
      href: '/oem-services',
    },
    {
      name: 'Contact Us',
      href: '/contact',
    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-brand-blue shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_foodholdings/artifacts/1p6ljk80_tengfoodholdings-logo.png"
                alt="Teng Food Holdings"
                className="h-12 w-auto"
              />
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold text-white">Teng Food Holdings</h1>
                <p className="text-sm text-brand-light">Food Manufacturing Excellence</p>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex">
            <ul className="flex space-x-8">
              {navigation.map((item) => (
                <li key={item.name} className="relative group">
                  {item.children ? (
                    <>
                      <button className="text-white hover:text-brand-coral font-medium flex items-center space-x-1 transition-colors py-2">
                        <span>{item.name}</span>
                        <ChevronDown className="h-4 w-4 group-hover:rotate-180 transition-transform duration-200" />
                      </button>
                      <div className="absolute top-full left-0 mt-1 w-56 bg-white shadow-lg rounded-md border border-brand-gray opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                        <div className="py-2">
                          {item.children.map((child) => (
                            <Link
                              key={child.name}
                              to={child.href}
                              className="block px-4 py-2 text-sm text-brand-charcoal hover:text-brand-red hover:bg-brand-light transition-colors"
                            >
                              {child.name}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <Link
                      to={item.href}
                      className={`text-white hover:text-brand-coral font-medium transition-colors py-2 block ${
                        isActive(item.href) ? 'text-brand-coral' : ''
                      }`}
                    >
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-brand-coral transition-colors"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-brand-charcoal">
            <div className="space-y-2">
              {navigation.map((item) => (
                <div key={item.name}>
                  <Link
                    to={item.href}
                    className={`block px-4 py-2 text-white hover:text-brand-coral font-medium transition-colors ${
                      isActive(item.href) ? 'text-brand-coral' : ''
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                  {item.children && (
                    <div className="ml-4 space-y-1">
                      {item.children.map((child) => (
                        <Link
                          key={child.name}
                          to={child.href}
                          className="block px-4 py-2 text-sm text-brand-light hover:text-brand-coral transition-colors"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {child.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;